import { createSelector } from 'reselect';

import { initialState, key } from './reducer';
import { createSelectFieldOptions } from '../../utils/common';
import { selectListData } from '../../store/selectors';

export const selectVenueModalDomain = state => state[key] || initialState;

const selectCountriesOptions = () =>
  createSelector(selectListData(selectVenueModalDomain, initialState.countries.listName), data =>
    createSelectFieldOptions(data, 'id', 'name', {}, true),
  );

const selectImageFormatsNames = () =>
  createSelector(selectListData(selectVenueModalDomain, initialState.imageFormats.listName), data =>
    data.map(f => f?.slug),
  );

export { selectCountriesOptions, selectImageFormatsNames };
